import React from "react";
import { Link } from "react-router-dom";

import Img1 from "../img/project-s-11.jpg";
import Img2 from "../img/plan.png";
import Img3 from "../img/24-hours.png";
import Img4 from "../img/group.png";
import Img5 from "../img/best-price.png";
import Img6 from "../img/bedroom-2.jpg";
import Img7 from "../img/hallroom.jpg";
import Img8 from "../img/kitchen-3.png";

// import "./style.css";

const ProjectSingle11 = () => {
  return (
    <section className="project-details-area">
      <div className="container">
        <div className="row">
          <div className="col-lg-12">
            <div className="project-details-top">
              <div className="project-details-top-img">
                <img src={Img1} alt="img" />
              </div>
              <div className="project-details-top-box">
                <h3>Project Details</h3>
                <div className="row">
                  <div className="col-lg-6">
                    <div className="project-details-top-box-text">
                      <h5>Project</h5>
                      <p>Interior</p>
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="project-details-top-box-text">
                      <h5>Location</h5>
                      <p>MAHIM</p>
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="project-details-top-box-text">
                      <h5>Year</h5>
                      <p>2020</p>
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="project-details-top-box-text">
                      <h5>Type</h5>
                      <p>Residential</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="project-details-top-text">
              <h2>Best Exterior Ideas</h2>
              <p>
               SBIMilan Heights stands as a beacon of contemporary living in the heart of Mahim, one of Mumbai's most historic and well-connected neighborhoods. This modern residential masterpiece is designed to elevate your lifestyle, providing residents with a perfect blend of comfort, convenience, and sophistication.
              </p>
              <p>
                <h3> - Architectural Excellence - </h3>
                SBIMilan Heights is an architectural marvel, seamlessly blending modern design with a touch of timeless elegance, creating a building that's as visually appealing as it is functional:
              </p>
              <p>
                <h3> - Community and Lifestyle - </h3>
                SBIMilan Heights isn't just a building; it's a community where residents can forge meaningful connections and embrace a high-quality lifestyle:
              </p>
              <p>
                <h3> - Conclusion - </h3>

                Experience the epitome of luxury living at SBIMilan Heights. It's more than a residence; it's a lifestyle choice where every detail is designed to provide you with comfort, elegance, and a vibrant community. Embrace the SBIMilan way of life, where every day feels like a celebration of modern living in the heart of Mahim.
              </p>
            </div>
            <div className="project-overview">
              <div className="row">
                <div className="col-lg-3 col-6">
                  <div className="project-overview-box">
                    <img src={Img2} alt="img" />
                    <h5>Project size</h5>
                    <p>40100 sq ft</p>
                  </div>
                </div>
                <div className="col-lg-3 col-6">
                  <div className="project-overview-box">
                    <img src={Img3} alt="img" />
                    <h5>Project time</h5>
                    <p>2 Years</p>
                  </div>
                </div>
                <div className="col-lg-3 col-6">
                  <div className="project-overview-box">
                    <img src={Img4} alt="img" />
                    <h5>People worked</h5>
                    <p>180</p>
                  </div>
                </div>
                <div className="col-lg-3 col-6">
                  <div className="project-overview-box">
                    <img src={Img5} alt="img" />
                    <h5>Project cost</h5>
                    <p>₹ 205cr</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="project-details-type">
              <div className="row">
                <div className="col-md-4">
                  <div className="details-box">
                    <div className="project-box project-details-box">
                      <img src={Img6} alt="img" />
                      <p>BEDROOM</p>
                    </div>
                    <div className="project-details-box-meta-text">
                      <p>
                        Step into the luxurious embrace of comfort and tranquility within SBIMilan Residences. Our bedrooms are meticulously designed to provide the perfect blend of relaxation, style, and practicality.
                      </p>
                      
                    </div>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="details-box">
                    <div className="project-box project-details-box">
                      <img src={Img7} alt="img" />
                      <p>HALLROOM</p>
                    </div>
                    <div className="project-details-box-meta-text">
                      <p>
                        Discover the heart of SBIMilan Residences – our versatile and inviting living spaces. Our halls or living rooms are designed to be the hub of daily life and special gatherings.
                      </p>
                      
                    </div>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="details-box">
                    <div className="project-box project-details-box">
                      <img src={Img8} alt="img" />
                      <p>KITCHEN</p>
                    </div>
                    <div className="project-details-box-meta-text">
                      <p>
                        Experience culinary excellence in our meticulously designed kitchens. SBIMilan's kitchens are more than just functional; they're designed to inspire your culinary creativity.
                      </p>
                      
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
export default ProjectSingle11;
